import React from "react";
import styled from 'styled-components';

const Header = styled.div`
    background-color: #08DE9E;
    width: 100%;
    padding: 15px;
    color: #ffffff;
    flex: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 15px;
    -webkit-box-shadow: -2px 2px 5px 1px rgba(0,0,0,0.2);
    box-shadow: -2px 2px 5px 1px rgba(0,0,0,0.2);
    z-index: 91;
    img {
        width: 40px;
        height: 40px;
        -object-fit: fill;
        object-fit: fill;
        padding: 7px;
        border-radius: 200px;
        cursor: pointer;
        background-color: #FFFFFF;
        &.close {
            display: none;
            background-color: transparent;
        }
    }
    button {
        border: none;
        width: auto;
        font-family: 'DM Sans' !important;
        background-color: #ffffff !important;
        color: #07131e !important;
        font-size: 15px !important;
        font-weight: 100 !important;
        padding: 4px 24px 4px 24px !important;
        border-radius: 100px !important;
        transition: all 0.3s ease-in-out 0s;
        &:hover {
            background-color: #36d093 !important;
        }
    }
    a {
        color: #000000;
        text-decoration: none;
        width: auto;
        &:hover {
            text-decoration: none !important;
            cursor: pointer;
        }
    }
    span {
        padding: 0px;
    }
    @media (max-width: 576px) {
        img {
            &.close {
                display: block;
            }
        }
    }
`;

export default Header;